<template>
  <span>
    {{ vehicle.code }}
    <span v-if="vehicle.extraCode != null"> ─ {{ vehicle.extraCode }} </span>
    <v-chip small v-if="orgCode">{{ orgCode }}</v-chip>
    <v-chip small v-if="activeStatus" :color="activeStatus.color">
      {{ activeStatus.text }}
    </v-chip>
  </span>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    vehicle: { required: true },
    history: {}
  },
  computed: {
    orgCode() {
      if (this.vehicle.org == null) return null
      return this.vehicle.org.name
    },
    activeStatus() {
      if (this.history == null) return null
      let s = this.history.subType
      let text = moment(this.history.timestamp).fromNow()

      if (s == 'start' || s == 'install') {
        return { color: 'info', text: 'Instalado ' + text }
      } else {
        return { color: 'error', text: 'Retirado ' + text }
      }
    }
  }
}
</script>

<style></style>
